import { render, staticRenderFns } from "./PagamentosConfirmar.vue?vue&type=template&id=46b57b46&"
import script from "./PagamentosConfirmar.vue?vue&type=script&lang=js&"
export * from "./PagamentosConfirmar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports